<template>

  <van-popup
    class="location-popup"
    v-model="show"
    position="bottom"
    get-container="body"
    close-on-popstate
    @close="closePopup"
    :style="{ height: '90%' }">

    <div class="location-popup-container" v-if="show">
      <div class="header">
        <div class="handle-btn" @click="cancel">
          取消
        </div>
        <van-search
          v-model="searchStr"
          shape="round"
          @input="getInputSearch"
          placeholder="请输入搜索关键词"
        />
        <div class="handle-btn" @click="confirm">
          确定
        </div>
      </div>
      <div class="map-container">
        <el-amap vid="amap" ref="amap" class="amap-demo">
        </el-amap>
      </div>
      <div class="pois-container">
        <div
          class="pois-item"
          v-for="item in resultList"
          :key="item.id"
          @click="selectLocation(item)">
          <div class="left">
            <div class="title">
              <van-icon name="location"/>
              <div class="name">
                {{item.name}}
              </div>
            </div>
            <div class="address">
              {{item.pname}}{{item.cityname}}{{item.adname}}{{item.address}}
            </div>
          </div>
          <div class="right" :style="{display: selectLocationId === item.id ? 'flex' : 'none'}">
            <van-icon name="checked"/>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import {uuid} from "../RyForm/utils";
  import {objectArrayUnique} from "../../assets/js/Untis";

  export default {
    name: "LocationPopup",
    props: {
      scopeRadius: {
        type: Number,
        default: 500
      }
    },
    data() {
      return {
        show: false,
        mapObj: null,
        nearBy: null,
        marker: null,
        circle: null,
        positionPicker: null,
        resultList: [],

        locationInfo: {
          latitude: 0,
          longitude: 0
        },
        locationAddr: '',
        searchStr: '',
        selectLocationId: '',
        manualSelect: false, // 手动选址地点
        firstLoad: true,
      }
    },
    created() {
      if (this.$refs.amap && this.$refs.amap.$$getInstance) {
        this.mapObj = this.$refs.amap.$$getInstance()
      }
    },

    methods: {
      open() {

        this.show = true
        this.firstLoad = true

        setTimeout(() => {
          this.getLocation()
        }, 1000)

      },

      getLocation() {
        if (this.$refs.amap && this.$refs.amap.$$getInstance) {
          this.mapObj = this.$refs.amap.$$getInstance()
        }
        if (!this.mapObj) {
          return
        }

        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：无穷大
          maximumAge: 0,           //定位结果缓存0毫秒，默认：0
          convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true,        //显示定位按钮，默认：true
          buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        this.mapObj.addControl(geolocation);
        console.log(geolocation)
        geolocation.getCurrentPosition((status, result) => {
          console.log('result', status, result)
          if (status === 'complete') {//定位成功

            this.locationInfo.latitude = result.position.lat
            this.locationInfo.longitude = result.position.lng
            const address = result.addressComponent
            // this.locationAddr = address.province + address.city + address.district + address.township + address.street + address.streetNumber;

            this.mapObj.setCenter([this.locationInfo.longitude, this.locationInfo.latitude])


            if (this.scopeRadius !== -1) {
              this.circle = new AMap.Circle({
                center: new AMap.LngLat(this.locationInfo.longitude, this.locationInfo.latitude),// 圆心位置
                radius: this.scopeRadius, //半径
                strokeColor: "#FF33FF", //线颜色
                strokeOpacity: 0.2, //线透明度
                strokeWeight: 3,    //线宽
                fillColor: "#1791fc", //填充色
                fillOpacity: 0.05//填充透明度
              });

              this.circle.setMap(this.mapObj);//显示圆圈
            }

            this.mapObj.setFitView();//根据地图上添加的覆盖物分布情况，自动缩放地图到合适的视野级别
            this.mapObj.setZoom(15)

            this.getNearBy(this.locationInfo.longitude, this.locationInfo.latitude)

            this.settingDrag()
          }
          if (status === 'error') {//定位失败
            if (result.info === 'NOT_SUPPORTED') {
              alert("当前浏览器不支持定位功能");
              return false;
            }
            if (result.info === 'FAILED') {
              var msg = result.message;
              if (msg.indexOf('Get ipLocation failed') !== -1) {
                // alert("IP精确定位失败");
                return false;
              }
              if (msg.indexOf('sdk定位失败') !== -1) {
                alert("请检查sdk的key是否设置好，以及webview的定位权限及应用和系统的定位权限是否开启");
                return false;
              }
              if (msg.indexOf('Browser not Support html5 geolocation') !== -1) {
                alert("浏览器不支持原生定位接口");
                return false;
              }
              if (msg.indexOf('Geolocation permission denied') !== -1) {
                alert("用户禁用了定位权限");
                return false;
              }
              if (msg.indexOf('Get geolocation time out') !== -1) {
                alert("浏览器定位超时");
                return false;
              }
              if (msg.indexOf('Get geolocation failed') !== -1) {
                alert("定位失败");
                return false;
              }
            }
          }
        });

        //地图加载失败
        this.mapObj.on("error", function () {
          alert("地图加载失败，请重新进入页面或刷新当前页面重试");
        });

      },

      settingDrag() {
        AMapUI.loadUI(['misc/PositionPicker'], PositionPicker => {

          if (!this.positionPicker) {
            this.positionPicker = new PositionPicker({
              mode: 'dragMap',
              map: this.mapObj
            });

            this.positionPicker.on('success', positionResult => {
              console.log('circle', this.circle)
              if (this.circle || this.scopeRadius === -1) {
                let isInScope = true
                if (this.scopeRadius === -1) {
                  isInScope = true
                } else {
                  isInScope = this.circle.contains(new AMap.LngLat(positionResult.position.lng, positionResult.position.lat))
                }
                console.log('positionPicker - success ', positionResult, isInScope, this.manualSelect)
                if (isInScope) {
                  if (!this.manualSelect) {
                    const aois = positionResult.regeocode.aois[0]
                    let name = ''
                    let id = ''
                    let location = ''
                    if (aois) {
                      name = aois.name
                      id = aois.id
                      location = aois.location
                    } else {
                      id = uuid()
                      name = positionResult.address
                      location = positionResult.position
                    }

                    const item = {
                      adcode: positionResult.regeocode.addressComponent.adcode,
                      address: positionResult.nearestJunction,
                      adname: positionResult.regeocode.addressComponent.district,
                      citycode: positionResult.regeocode.addressComponent.citycode,
                      cityname: positionResult.regeocode.addressComponent.city,
                      id,
                      location,
                      name,
                      pname: positionResult.regeocode.addressComponent.province,
                    }

                    this.selectLocationId = item.id

                    if (this.scopeRadius === -1) {

                      this.getNearBy(item.location.lng, item.location.lat, item)
                    } else {

                      for (let i = this.resultList.length - 1; i >= 0; i--) {
                        const place = this.resultList[i]
                        if (place.id === item.id) {
                          this.resultList.splice(i, 1)
                        }
                      }

                      this.resultList.splice(0, 1, item)
                    }

                  }
                  this.manualSelect = false
                  this.$notify.clear()
                } else {
                  this.selectLocationId = ''
                  if (!this.firstLoad) {
                    this.$notify({
                      message: '定位超出微调范围，请调整',
                      color: '#ad0000',
                      background: '#ffe1e1',
                      duration: 0
                    });
                  }
                }
              }
              if (this.firstLoad) {
                // this.mapObj.setZoom(15)
              }
              this.firstLoad = false
            });
            this.positionPicker.on('fail', function (positionResult) {
              console.log('positionPicker - fail ', positionResult)
            });

            // 两种模式 dragMap dragMarker
            this.positionPicker.setMode('dragMap')

            this.positionPicker.start();
            // this.mapObj.panBy(0, 1);

            // this.mapObj.addControl(new AMap.ToolBar({
            //   liteStyle: true
            // }))
          }

        })

      },
      // 创建地点查询类的实例
      getNearBy(lng, lat, positionItem) {
        this.resultList.splice(0, this.resultList.length)
        AMap.service('AMap.PlaceSearch', () => {
          let type = '汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施'
          if (!this.nearBy) {
            this.nearBy = new AMap.PlaceSearch({
              type: type,
              pageSize: 150,
              pageIndex: 1,
              extensions: 'all'
            })
          }
          // 周边搜索（类型，经纬度，范围，回调函数）
          const scopeRadius = this.scopeRadius === -1 ? 0 : this.scopeRadius
          this.nearBy.searchNearBy('', [lng, lat], scopeRadius, (status, result) => {
            // 获取返回值做处理
            console.log('searchNearBy--result--', result)
            if (result && result.poiList) {
              result.poiList.pois.forEach(item => {
                if (item.address &&
                  item.name &&
                  item.location.lat !== this.locationInfo.latitude &&
                  item.location.lng !== this.locationInfo.longitude) {
                  this.resultList.push(item)
                }
              })
            }

            if (positionItem && !this.resultList.map(item => item.id).includes(positionItem.id)) {
              this.resultList.unshift(positionItem)
            }
            this.resultList = objectArrayUnique(this.resultList, 'id')

            console.log('searchNearBy', result, this.resultList)
          })
        })
      },


      getInputSearch() {
        AMap.service('AMap.PlaceSearch', () => {
          let type = '汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施'
          if (!this.nearBy) {
            this.nearBy = new AMap.PlaceSearch({
              type: type,
              pageSize: 150,
              pageIndex: 1,
              extensions: 'all'
            })
          }
          // 周边搜索（类型，经纬度，范围，回调函数）
          if (this.scopeRadius === -1) {
            this.nearBy.search(this.searchStr, (status, result) => {
              // 获取返回值做处理
              this.resultList.splice(0, this.resultList.length)
              if (result && result.poiList) {
                result.poiList.pois.forEach(item => {
                  if (item.address && item.name) {
                    this.resultList.push(item)
                  }
                })
              }
            })
          } else {
            this.nearBy.searchNearBy(this.searchStr, [this.locationInfo.longitude, this.locationInfo.latitude], this.scopeRadius, (status, result) => {
              // 获取返回值做处理
              this.resultList.splice(0, this.resultList.length)
              if (result && result.poiList) {
                result.poiList.pois.forEach(item => {
                  if (item.address && item.name) {
                    this.resultList.push(item)
                  }
                })
              }
            })
          }

          this.resultList = objectArrayUnique(this.resultList, 'id')
        })

      },
      getAddress(x, y) {
        AMap.plugin(['AMap.Geocoder'], () => {
          let geocoder = new AMap.Geocoder({})
          geocoder.getAddress([x, y], (status, result) => {
            if (status === 'complete' && result.regeocode) {
              // 处理返回结果
            }
          })
        })
      },
      selectLocation(item) {
        console.log('selectLocation', item)
        this.manualSelect = true
        this.selectLocationId = item.id
        this.mapObj.setCenter([item.location.lng, item.location.lat])
      },

      cancel() {
        this.show = false
      },
      confirm() {
        const selectItem = this.resultList.filter(item => item.id === this.selectLocationId)[0]
        if (!selectItem) {
          this.$toast.fail('请选择定位')
          return
        }
        this.show = false
        this.$emit('selectComplete', {
          latitude: selectItem.location.lat,
          longitude: selectItem.location.lng
        })
      },
      closePopup() {

        if (!this.mapObj) {
          return
        }
        console.log('closePopup')
        this.mapObj.clearMap()
        this.$notify.clear()
        this.positionPicker = null
      }
    }
  }
</script>

<style lang="less">

  .location-popup {

    .location-popup-container {
      height: 100%;

      .header {
        height: 60px;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 10px;

        .handle-btn {
          font-size: 14px;
          color: #2d8cf0;
          width: 40px;
          text-align: center;
        }

        .van-search {
          flex: 1;
        }
      }

      .map-container {
        height: 260px;
        width: 100%;
      }

      .pois-container {
        height: calc(100% - 320px);
        width: 100%;
        overflow: auto;

        .pois-item {
          width: 100%;
          padding: 10px;
          border-bottom: 1px solid #e6e6e6;
          display: flex;

          .left {
            width: calc(100% - 40px);

            .title {
              display: flex;
              margin-bottom: 10px;
              align-items: center;

              .van-icon {
                color: #9F9F9F;
                margin-right: 5px;
              }

              .name {
                font-size: 14px;
                color: #333333;
              }
            }

            .address {
              font-size: 12px;
              color: #9e9e9e;
              line-height: 18px;
            }
          }

          .right {
            height: 40px;
            width: 40px;
            display: flex;
            align-items: center;
            justify-content: center;

            .van-icon {
              color: #05A971;
            }
          }
        }
      }
    }

  }
</style>